import { Component, Input } from '@angular/core';

@Component({
  selector: 'ui-fh-svg-medicine',
  templateUrl: './fh-svg-medicine.component.html',
  styleUrl: './fh-svg-medicine.component.scss'
})
export class FhSvgMedicineComponent {
  @Input() color: string = '';
}
